module.exports = __webpack_public_path__ + "img/a8.7260d38e.png";